/*
 * Author: Dw
 * File Created: Friday, 24-07-19 09:35 pm
 * Last Modified: Tuesday, 24-09-03 01:56 pm, by Harper Yan
 */

import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material/styles';

type MuiDrawerThemeOptions = {
  defaultProps?: ComponentsProps['MuiDrawer'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiDrawer'];
  variants?: ComponentsVariants<Theme>['MuiDrawer'];
};

export const MuiDrawer: MuiDrawerThemeOptions = {
  styleOverrides: {
    root: ({ theme }) => ({
      background: 'rgba(0, 0, 0, 0.50)',
    }),
    paper: () => ({
      background: '#1B1E27',
      overflowX: 'hidden',
    }),
  },
};
